var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleClassroom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6258_2136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.81818 10.1818H58.1818V53.8182H5.81818V10.1818Z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6363 33.4545C45.4424 33.4545 46.9091 31.9879 46.9091 30.1818C46.9091 28.3758 45.4424 26.9091 43.6363 26.9091C41.8303 26.9091 40.3636 28.3758 40.3636 30.1818C40.3636 31.9879 41.8303 33.4545 43.6363 33.4545ZM43.6363 35.6364C40.1333 35.6364 36.3636 37.4909 36.3636 39.7939V42.1818H50.9091V39.7939C50.9091 37.4909 47.1394 35.6364 43.6363 35.6364ZM20.3636 33.4545C22.1697 33.4545 23.6363 31.9879 23.6363 30.1818C23.6363 28.3758 22.1697 26.9091 20.3636 26.9091C18.5575 26.9091 17.0909 28.3758 17.0909 30.1818C17.0909 31.9879 18.5575 33.4545 20.3636 33.4545ZM20.3636 35.6364C16.8606 35.6364 13.0909 37.4909 13.0909 39.7939V42.1818H27.6363V39.7939C27.6363 37.4909 23.8666 35.6364 20.3636 35.6364Z",
    fill: "#57BB8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 30.5454C34.4121 30.5454 36.3636 28.5939 36.3636 26.1818C36.3636 23.7697 34.4121 21.8182 32 21.8182C29.5879 21.8182 27.6364 23.7697 27.6364 26.1818C27.6364 28.5939 29.5879 30.5454 32 30.5454ZM32 33.4545C27.0909 33.4545 21.8182 36.0606 21.8182 39.2727V42.1818H42.1818V39.2727C42.1818 36.0606 36.9091 33.4545 32 33.4545Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8182 50.9091H50.9091V53.8182H37.8182V50.9091Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6364 4.36363H4.36364C1.95152 4.36363 0 6.31515 0 8.72727V55.2727C0 57.6848 1.95152 59.6364 4.36364 59.6364H59.6364C62.0485 59.6364 64 57.6848 64 55.2727V8.72727C64 6.31515 62.0485 4.36363 59.6364 4.36363ZM58.1818 53.8182H5.81818V10.1818H58.1818V53.8182Z",
    fill: "#F4B400"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M59.6364 4.36363H4.36364C1.95152 4.36363 0 6.31515 0 8.72727V9.0909C0 6.67878 1.95152 4.72727 4.36364 4.72727H59.6364C62.0485 4.72727 64 6.67878 64 9.0909V8.72727C64 6.31515 62.0485 4.36363 59.6364 4.36363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M59.6364 59.2727H4.36364C1.95152 59.2727 0 57.3212 0 54.9091V55.2727C0 57.6848 1.95152 59.6364 4.36364 59.6364H59.6364C62.0485 59.6364 64 57.6848 64 55.2727V54.9091C64 57.3212 62.0485 59.2727 59.6364 59.2727Z",
    fill: "#BF360C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8849 53.8182H37.7939L43.6121 59.6364H56.6909L50.8849 53.8182Z",
    fill: "url(#paint0_linear_6258_2136)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M5.81818 9.81818H58.1818V10.1818H5.81818V9.81818Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M5.81818 53.8182H58.1818V54.1818H5.81818V53.8182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6364 4.36363H4.36364C1.95152 4.36363 0 6.31515 0 8.72727V55.2727C0 57.6848 1.95152 59.6364 4.36364 59.6364H59.6364C62.0485 59.6364 64 57.6848 64 55.2727V8.72727C64 6.31515 62.0485 4.36363 59.6364 4.36363Z",
    fill: "url(#paint1_radial_6258_2136)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6258_2136",
    x1: 5026.89,
    y1: 90.5635,
    x2: 5026.89,
    y2: 2734.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF360C",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF360C",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6258_2136",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(994.302 595.15) scale(139426 139425)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6258_2136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleClassroom);
export default __webpack_public_path__ + "static/media/google-classroom.251754f54cb5a6a07dd5f476272dabf5.svg";
export { ForwardRef as ReactComponent };